export default __webpack_public_path__ + "static/media/img-ln-1-gift-profile.ac4f1069.png";